const general = {
    /**
    forum: {
        icon: 'usergroup-add',
        text: 'Forum',
        route: 'admin.classical.forum',
    },
     */
    observation: {
        icon: 'file-search',
        text: 'Observasi',
        route: 'admin.classical.observation',
        role: {
            classical: [ 'project-manager' ],
        }
    },
    /**
    mentoring: {
        icon: 'solution',
        text: 'Mentoring',
        route: 'admin.classical.mentoring',
    },
    */
    examSession: {
        icon: 'calendar',
        text: 'Sesi Ujian',
        route: 'admin.classical.exam.sessions',
        role: {
            classical: [ 'admin', 'project-manager' ],
        }
    },
    generalObservasi: {
        icon: 'file-search',
        text: 'Observasi',
        route: 'admin.classical.observation',
        role: {
            classical: [ 'admin', 'project-owner', 'inspirator', 'project-manager-client', 'project-owner-client', 'project-sponsor' ],
        }
    },
    evaluation: {
        icon: 'carry-out',
        text: 'Evaluasi Pelaksanaan',
        route: 'admin.classical.admin.evaluation.summary',
        role: {
            classical: [ 'admin', 'project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor' ]
        }
    },
    report: {
        icon: 'file-protect',
        text: 'Report',
        route: 'admin.classical.report',
        role: {
            classical: [ 'project-manager', 'project-owner', 'inspirator', 'project-manager-client', 'project-owner-client', 'project-sponsor' ],
        }
    },
    pengumuman: {
        icon: 'notification',
        text: 'Pengumuman',
        route: 'admin.classical.announcement',
        role: {
            classical: [ 'attendant', 'project-manager', 'project-owner', 'inspirator', 'project-manager-client', 'project-owner-client', 'project-sponsor' ],
        }
    },
    information: {
        icon: 'info-circle',
        text: 'Information Center',
        route: 'admin.classical.information',
        role: {
            classical: [ 'attendant', 'project-manager', 'project-owner', 'inspirator', 'project-manager-client', 'project-owner-client', 'project-sponsor' ],
        }
    },
}

export default general
